// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 * OutboundMessageStatus contains a list of message statuses for outgoing messages.
 */
export var OutboundMessageStatus;
(function (OutboundMessageStatus) {
    OutboundMessageStatus["UNSPECIFIED"] = "UNSPECIFIED";
    OutboundMessageStatus["IN_PROCESS"] = "IN_PROCESS";
    OutboundMessageStatus["SENT"] = "SENT";
    OutboundMessageStatus["DELIVERED"] = "DELIVERED";
    OutboundMessageStatus["NOT_SENT"] = "NOT_SENT";
    OutboundMessageStatus["ERROR"] = "ERROR";
    OutboundMessageStatus["SCHEDULED"] = "SCHEDULED";
    OutboundMessageStatus["CANCELED"] = "CANCELED";
    OutboundMessageStatus["SCHEDULED_RETRY"] = "SCHEDULED_RETRY";
    OutboundMessageStatus["DRAFT"] = "DRAFT";
    OutboundMessageStatus["INVALID_DESTINATION"] = "INVALID_DESTINATION";
    OutboundMessageStatus["OPTED_OUT"] = "OPTED_OUT";
    OutboundMessageStatus["DELETED"] = "DELETED";
    OutboundMessageStatus["PAUSED"] = "PAUSED";
    OutboundMessageStatus["SUPPRESSED"] = "SUPPRESSED";
    OutboundMessageStatus["VOICEMAIL"] = "VOICEMAIL";
    OutboundMessageStatus["GROUPED"] = "GROUPED";
    OutboundMessageStatus["NOT_DELIVERED"] = "NOT_DELIVERED";
})(OutboundMessageStatus || (OutboundMessageStatus = {}));
export var OutboundMessageStatus_index;
(function (OutboundMessageStatus_index) {
    OutboundMessageStatus_index[OutboundMessageStatus_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    OutboundMessageStatus_index[OutboundMessageStatus_index["IN_PROCESS"] = 1] = "IN_PROCESS";
    OutboundMessageStatus_index[OutboundMessageStatus_index["SENT"] = 2] = "SENT";
    OutboundMessageStatus_index[OutboundMessageStatus_index["DELIVERED"] = 3] = "DELIVERED";
    OutboundMessageStatus_index[OutboundMessageStatus_index["NOT_SENT"] = 4] = "NOT_SENT";
    OutboundMessageStatus_index[OutboundMessageStatus_index["ERROR"] = 5] = "ERROR";
    OutboundMessageStatus_index[OutboundMessageStatus_index["SCHEDULED"] = 6] = "SCHEDULED";
    OutboundMessageStatus_index[OutboundMessageStatus_index["CANCELED"] = 7] = "CANCELED";
    OutboundMessageStatus_index[OutboundMessageStatus_index["SCHEDULED_RETRY"] = 8] = "SCHEDULED_RETRY";
    OutboundMessageStatus_index[OutboundMessageStatus_index["DRAFT"] = 9] = "DRAFT";
    OutboundMessageStatus_index[OutboundMessageStatus_index["INVALID_DESTINATION"] = 10] = "INVALID_DESTINATION";
    OutboundMessageStatus_index[OutboundMessageStatus_index["OPTED_OUT"] = 11] = "OPTED_OUT";
    OutboundMessageStatus_index[OutboundMessageStatus_index["DELETED"] = 12] = "DELETED";
    OutboundMessageStatus_index[OutboundMessageStatus_index["PAUSED"] = 13] = "PAUSED";
    OutboundMessageStatus_index[OutboundMessageStatus_index["SUPPRESSED"] = 14] = "SUPPRESSED";
    OutboundMessageStatus_index[OutboundMessageStatus_index["VOICEMAIL"] = 15] = "VOICEMAIL";
    OutboundMessageStatus_index[OutboundMessageStatus_index["GROUPED"] = 16] = "GROUPED";
    OutboundMessageStatus_index[OutboundMessageStatus_index["NOT_DELIVERED"] = 17] = "NOT_DELIVERED";
})(OutboundMessageStatus_index || (OutboundMessageStatus_index = {}));
/**
 * ProcessingPolicy defines the processing policy for a message.
 */
export var ProcessingPolicy;
(function (ProcessingPolicy) {
    ProcessingPolicy["UNSPECIFIED_PROCESSING_POLICY"] = "UNSPECIFIED_PROCESSING_POLICY";
    ProcessingPolicy["PRIORITY"] = "PRIORITY";
    ProcessingPolicy["FLEXIBLE"] = "FLEXIBLE";
    ProcessingPolicy["TEST"] = "TEST";
    ProcessingPolicy["TEST_FORCE_ERROR"] = "TEST_FORCE_ERROR";
    ProcessingPolicy["URGENT"] = "URGENT";
})(ProcessingPolicy || (ProcessingPolicy = {}));
export var ProcessingPolicy_index;
(function (ProcessingPolicy_index) {
    ProcessingPolicy_index[ProcessingPolicy_index["UNSPECIFIED_PROCESSING_POLICY"] = 0] = "UNSPECIFIED_PROCESSING_POLICY";
    ProcessingPolicy_index[ProcessingPolicy_index["PRIORITY"] = 1] = "PRIORITY";
    ProcessingPolicy_index[ProcessingPolicy_index["FLEXIBLE"] = 2] = "FLEXIBLE";
    ProcessingPolicy_index[ProcessingPolicy_index["TEST"] = 3] = "TEST";
    ProcessingPolicy_index[ProcessingPolicy_index["TEST_FORCE_ERROR"] = 4] = "TEST_FORCE_ERROR";
    ProcessingPolicy_index[ProcessingPolicy_index["URGENT"] = 5] = "URGENT";
})(ProcessingPolicy_index || (ProcessingPolicy_index = {}));
/**
 * Defines the available sort directions for requests
 */
export var SortDirection;
(function (SortDirection) {
    SortDirection["DIRECTION_UNSPECIFIED"] = "DIRECTION_UNSPECIFIED";
    SortDirection["ASCENDING"] = "ASCENDING";
    SortDirection["DESCENDING"] = "DESCENDING";
})(SortDirection || (SortDirection = {}));
export var SortDirection_index;
(function (SortDirection_index) {
    SortDirection_index[SortDirection_index["DIRECTION_UNSPECIFIED"] = 0] = "DIRECTION_UNSPECIFIED";
    SortDirection_index[SortDirection_index["ASCENDING"] = 1] = "ASCENDING";
    SortDirection_index[SortDirection_index["DESCENDING"] = 2] = "DESCENDING";
})(SortDirection_index || (SortDirection_index = {}));
export var SourceSystem_Enum;
(function (SourceSystem_Enum) {
    SourceSystem_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    SourceSystem_Enum["MESSAGING_AUTO_QUEUE_SENDER"] = "MESSAGING_AUTO_QUEUE_SENDER";
    SourceSystem_Enum["BULK_MESSAGING"] = "BULK_MESSAGING";
    SourceSystem_Enum["AUTO_WORKER"] = "AUTO_WORKER";
    SourceSystem_Enum["MANUAL_MESSAGES"] = "MANUAL_MESSAGES";
    SourceSystem_Enum["REVIEWS"] = "REVIEWS";
})(SourceSystem_Enum || (SourceSystem_Enum = {}));
export var SourceSystem_Enum_index;
(function (SourceSystem_Enum_index) {
    SourceSystem_Enum_index[SourceSystem_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    SourceSystem_Enum_index[SourceSystem_Enum_index["MESSAGING_AUTO_QUEUE_SENDER"] = 1] = "MESSAGING_AUTO_QUEUE_SENDER";
    SourceSystem_Enum_index[SourceSystem_Enum_index["BULK_MESSAGING"] = 2] = "BULK_MESSAGING";
    SourceSystem_Enum_index[SourceSystem_Enum_index["AUTO_WORKER"] = 3] = "AUTO_WORKER";
    SourceSystem_Enum_index[SourceSystem_Enum_index["MANUAL_MESSAGES"] = 4] = "MANUAL_MESSAGES";
    SourceSystem_Enum_index[SourceSystem_Enum_index["REVIEWS"] = 5] = "REVIEWS";
})(SourceSystem_Enum_index || (SourceSystem_Enum_index = {}));
/**
 * Destination Type supported via auto messaging. Including: sms, email
 */
export var DestinationType_Enum;
(function (DestinationType_Enum) {
    DestinationType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    DestinationType_Enum["SMS"] = "SMS";
    DestinationType_Enum["EMAIL"] = "EMAIL";
    DestinationType_Enum["ROBOCALL"] = "ROBOCALL";
})(DestinationType_Enum || (DestinationType_Enum = {}));
export var DestinationType_Enum_index;
(function (DestinationType_Enum_index) {
    DestinationType_Enum_index[DestinationType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    DestinationType_Enum_index[DestinationType_Enum_index["SMS"] = 1] = "SMS";
    DestinationType_Enum_index[DestinationType_Enum_index["EMAIL"] = 2] = "EMAIL";
    DestinationType_Enum_index[DestinationType_Enum_index["ROBOCALL"] = 3] = "ROBOCALL";
})(DestinationType_Enum_index || (DestinationType_Enum_index = {}));
export var TriggerType_Enum;
(function (TriggerType_Enum) {
    TriggerType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    TriggerType_Enum["APPOINTMENT"] = "APPOINTMENT";
    TriggerType_Enum["RECALL"] = "RECALL";
    TriggerType_Enum["ORDER"] = "ORDER";
    TriggerType_Enum["BIRTHDAY"] = "BIRTHDAY";
    TriggerType_Enum["CALL"] = "CALL";
    TriggerType_Enum["SMS"] = "SMS";
    TriggerType_Enum["CONFIRMATION"] = "CONFIRMATION";
    TriggerType_Enum["INVOICE"] = "INVOICE";
})(TriggerType_Enum || (TriggerType_Enum = {}));
export var TriggerType_Enum_index;
(function (TriggerType_Enum_index) {
    TriggerType_Enum_index[TriggerType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    TriggerType_Enum_index[TriggerType_Enum_index["APPOINTMENT"] = 1] = "APPOINTMENT";
    TriggerType_Enum_index[TriggerType_Enum_index["RECALL"] = 2] = "RECALL";
    TriggerType_Enum_index[TriggerType_Enum_index["ORDER"] = 3] = "ORDER";
    TriggerType_Enum_index[TriggerType_Enum_index["BIRTHDAY"] = 4] = "BIRTHDAY";
    TriggerType_Enum_index[TriggerType_Enum_index["CALL"] = 5] = "CALL";
    TriggerType_Enum_index[TriggerType_Enum_index["SMS"] = 6] = "SMS";
    TriggerType_Enum_index[TriggerType_Enum_index["CONFIRMATION"] = 7] = "CONFIRMATION";
    TriggerType_Enum_index[TriggerType_Enum_index["INVOICE"] = 8] = "INVOICE";
})(TriggerType_Enum_index || (TriggerType_Enum_index = {}));
export var TriggerFilterType_Enum;
(function (TriggerFilterType_Enum) {
    TriggerFilterType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    TriggerFilterType_Enum["SOURCE_TENANT"] = "SOURCE_TENANT";
    TriggerFilterType_Enum["TYPE"] = "TYPE";
    TriggerFilterType_Enum["CODE"] = "CODE";
    TriggerFilterType_Enum["STATUS"] = "STATUS";
    TriggerFilterType_Enum["PRACTITIONER"] = "PRACTITIONER";
    TriggerFilterType_Enum["WORKSPACE"] = "WORKSPACE";
    TriggerFilterType_Enum["PERSON_STATUS"] = "PERSON_STATUS";
    TriggerFilterType_Enum["LEGACY_TYPE"] = "LEGACY_TYPE";
    TriggerFilterType_Enum["LEGACY_LOCATION"] = "LEGACY_LOCATION";
    TriggerFilterType_Enum["LEGACY_DATA_SOURCE"] = "LEGACY_DATA_SOURCE";
})(TriggerFilterType_Enum || (TriggerFilterType_Enum = {}));
export var TriggerFilterType_Enum_index;
(function (TriggerFilterType_Enum_index) {
    TriggerFilterType_Enum_index[TriggerFilterType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    TriggerFilterType_Enum_index[TriggerFilterType_Enum_index["SOURCE_TENANT"] = 1] = "SOURCE_TENANT";
    TriggerFilterType_Enum_index[TriggerFilterType_Enum_index["TYPE"] = 2] = "TYPE";
    TriggerFilterType_Enum_index[TriggerFilterType_Enum_index["CODE"] = 4] = "CODE";
    TriggerFilterType_Enum_index[TriggerFilterType_Enum_index["STATUS"] = 5] = "STATUS";
    TriggerFilterType_Enum_index[TriggerFilterType_Enum_index["PRACTITIONER"] = 6] = "PRACTITIONER";
    TriggerFilterType_Enum_index[TriggerFilterType_Enum_index["WORKSPACE"] = 7] = "WORKSPACE";
    TriggerFilterType_Enum_index[TriggerFilterType_Enum_index["PERSON_STATUS"] = 8] = "PERSON_STATUS";
    TriggerFilterType_Enum_index[TriggerFilterType_Enum_index["LEGACY_TYPE"] = 3] = "LEGACY_TYPE";
    TriggerFilterType_Enum_index[TriggerFilterType_Enum_index["LEGACY_LOCATION"] = 101] = "LEGACY_LOCATION";
    TriggerFilterType_Enum_index[TriggerFilterType_Enum_index["LEGACY_DATA_SOURCE"] = 102] = "LEGACY_DATA_SOURCE";
})(TriggerFilterType_Enum_index || (TriggerFilterType_Enum_index = {}));
/**
 * RecordType used in AMP / History
 */
export var RecordType_Enum;
(function (RecordType_Enum) {
    RecordType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    RecordType_Enum["PERSON"] = "PERSON";
    RecordType_Enum["APPOINTMENT"] = "APPOINTMENT";
    RecordType_Enum["RECALL"] = "RECALL";
    RecordType_Enum["ORDER"] = "ORDER";
    RecordType_Enum["CALL"] = "CALL";
    RecordType_Enum["SMS"] = "SMS";
    RecordType_Enum["EMAIL"] = "EMAIL";
    RecordType_Enum["CONTACT_INFO"] = "CONTACT_INFO";
    RecordType_Enum["APPOINTMENT_WRITEBACK"] = "APPOINTMENT_WRITEBACK";
    RecordType_Enum["PET"] = "PET";
    RecordType_Enum["SENTIMENT"] = "SENTIMENT";
    RecordType_Enum["PROCEDURE_LOG"] = "PROCEDURE_LOG";
    RecordType_Enum["INVOICE"] = "INVOICE";
})(RecordType_Enum || (RecordType_Enum = {}));
export var RecordType_Enum_index;
(function (RecordType_Enum_index) {
    RecordType_Enum_index[RecordType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RecordType_Enum_index[RecordType_Enum_index["PERSON"] = 1] = "PERSON";
    RecordType_Enum_index[RecordType_Enum_index["APPOINTMENT"] = 2] = "APPOINTMENT";
    RecordType_Enum_index[RecordType_Enum_index["RECALL"] = 3] = "RECALL";
    RecordType_Enum_index[RecordType_Enum_index["ORDER"] = 4] = "ORDER";
    RecordType_Enum_index[RecordType_Enum_index["CALL"] = 5] = "CALL";
    RecordType_Enum_index[RecordType_Enum_index["SMS"] = 6] = "SMS";
    RecordType_Enum_index[RecordType_Enum_index["EMAIL"] = 7] = "EMAIL";
    RecordType_Enum_index[RecordType_Enum_index["CONTACT_INFO"] = 8] = "CONTACT_INFO";
    RecordType_Enum_index[RecordType_Enum_index["APPOINTMENT_WRITEBACK"] = 9] = "APPOINTMENT_WRITEBACK";
    RecordType_Enum_index[RecordType_Enum_index["PET"] = 10] = "PET";
    RecordType_Enum_index[RecordType_Enum_index["SENTIMENT"] = 11] = "SENTIMENT";
    RecordType_Enum_index[RecordType_Enum_index["PROCEDURE_LOG"] = 12] = "PROCEDURE_LOG";
    RecordType_Enum_index[RecordType_Enum_index["INVOICE"] = 13] = "INVOICE";
})(RecordType_Enum_index || (RecordType_Enum_index = {}));
export var MessageContext_Enum;
(function (MessageContext_Enum) {
    MessageContext_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    MessageContext_Enum["APPOINTMENT_REMINDER"] = "APPOINTMENT_REMINDER";
    MessageContext_Enum["APPOINTMENT_FOLLOWUP"] = "APPOINTMENT_FOLLOWUP";
    MessageContext_Enum["BIRTHDAY_MESSAGE"] = "BIRTHDAY_MESSAGE";
    MessageContext_Enum["MISSED_CALL"] = "MISSED_CALL";
    MessageContext_Enum["ORDER_READY"] = "ORDER_READY";
    MessageContext_Enum["ORDER_FOLLOWUP"] = "ORDER_FOLLOWUP";
    MessageContext_Enum["RECALL_REMINDER"] = "RECALL_REMINDER";
    MessageContext_Enum["REVIEW_REQUEST"] = "REVIEW_REQUEST";
    MessageContext_Enum["SAVE_THE_DATE"] = "SAVE_THE_DATE";
    MessageContext_Enum["REACTIVATION"] = "REACTIVATION";
    MessageContext_Enum["RESCHEDULE"] = "RESCHEDULE";
    MessageContext_Enum["MISSED_TEXT"] = "MISSED_TEXT";
    MessageContext_Enum["CONFIRMED_APPOINTMENT"] = "CONFIRMED_APPOINTMENT";
    MessageContext_Enum["PAYMENT_REMINDER"] = "PAYMENT_REMINDER";
    MessageContext_Enum["BULK_MESSAGING"] = "BULK_MESSAGING";
    MessageContext_Enum["MANUAL_MESSAGE"] = "MANUAL_MESSAGE";
})(MessageContext_Enum || (MessageContext_Enum = {}));
export var MessageContext_Enum_index;
(function (MessageContext_Enum_index) {
    MessageContext_Enum_index[MessageContext_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    MessageContext_Enum_index[MessageContext_Enum_index["APPOINTMENT_REMINDER"] = 1] = "APPOINTMENT_REMINDER";
    MessageContext_Enum_index[MessageContext_Enum_index["APPOINTMENT_FOLLOWUP"] = 2] = "APPOINTMENT_FOLLOWUP";
    MessageContext_Enum_index[MessageContext_Enum_index["BIRTHDAY_MESSAGE"] = 3] = "BIRTHDAY_MESSAGE";
    MessageContext_Enum_index[MessageContext_Enum_index["MISSED_CALL"] = 4] = "MISSED_CALL";
    MessageContext_Enum_index[MessageContext_Enum_index["ORDER_READY"] = 5] = "ORDER_READY";
    MessageContext_Enum_index[MessageContext_Enum_index["ORDER_FOLLOWUP"] = 6] = "ORDER_FOLLOWUP";
    MessageContext_Enum_index[MessageContext_Enum_index["RECALL_REMINDER"] = 7] = "RECALL_REMINDER";
    MessageContext_Enum_index[MessageContext_Enum_index["REVIEW_REQUEST"] = 8] = "REVIEW_REQUEST";
    MessageContext_Enum_index[MessageContext_Enum_index["SAVE_THE_DATE"] = 9] = "SAVE_THE_DATE";
    MessageContext_Enum_index[MessageContext_Enum_index["REACTIVATION"] = 10] = "REACTIVATION";
    MessageContext_Enum_index[MessageContext_Enum_index["RESCHEDULE"] = 11] = "RESCHEDULE";
    MessageContext_Enum_index[MessageContext_Enum_index["MISSED_TEXT"] = 12] = "MISSED_TEXT";
    MessageContext_Enum_index[MessageContext_Enum_index["CONFIRMED_APPOINTMENT"] = 13] = "CONFIRMED_APPOINTMENT";
    MessageContext_Enum_index[MessageContext_Enum_index["PAYMENT_REMINDER"] = 14] = "PAYMENT_REMINDER";
    MessageContext_Enum_index[MessageContext_Enum_index["BULK_MESSAGING"] = 30] = "BULK_MESSAGING";
    MessageContext_Enum_index[MessageContext_Enum_index["MANUAL_MESSAGE"] = 40] = "MANUAL_MESSAGE";
})(MessageContext_Enum_index || (MessageContext_Enum_index = {}));
/**
 * LanguageType used in AMP
 */
export var LanguageType_Enum;
(function (LanguageType_Enum) {
    LanguageType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    LanguageType_Enum["ENGLISH"] = "ENGLISH";
    LanguageType_Enum["SPANISH"] = "SPANISH";
    LanguageType_Enum["FRENCH"] = "FRENCH";
})(LanguageType_Enum || (LanguageType_Enum = {}));
export var LanguageType_Enum_index;
(function (LanguageType_Enum_index) {
    LanguageType_Enum_index[LanguageType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    LanguageType_Enum_index[LanguageType_Enum_index["ENGLISH"] = 1] = "ENGLISH";
    LanguageType_Enum_index[LanguageType_Enum_index["SPANISH"] = 2] = "SPANISH";
    LanguageType_Enum_index[LanguageType_Enum_index["FRENCH"] = 3] = "FRENCH";
})(LanguageType_Enum_index || (LanguageType_Enum_index = {}));
/**
 * Subject represents the subject of the message. Is it a person, or a pet.
 */
export var SubjectType_Enum;
(function (SubjectType_Enum) {
    SubjectType_Enum["PERSON"] = "PERSON";
    SubjectType_Enum["PET"] = "PET";
})(SubjectType_Enum || (SubjectType_Enum = {}));
export var SubjectType_Enum_index;
(function (SubjectType_Enum_index) {
    SubjectType_Enum_index[SubjectType_Enum_index["PERSON"] = 0] = "PERSON";
    SubjectType_Enum_index[SubjectType_Enum_index["PET"] = 1] = "PET";
})(SubjectType_Enum_index || (SubjectType_Enum_index = {}));
export var CampaignStatus_Enum;
(function (CampaignStatus_Enum) {
    CampaignStatus_Enum["CAMPAIGN_STATUS_UNSPECIFIED"] = "CAMPAIGN_STATUS_UNSPECIFIED";
    CampaignStatus_Enum["SCHEDULED"] = "SCHEDULED";
    CampaignStatus_Enum["PROCESSING"] = "PROCESSING";
    CampaignStatus_Enum["COMPLETED"] = "COMPLETED";
    CampaignStatus_Enum["CANCELED"] = "CANCELED";
    CampaignStatus_Enum["DELETED"] = "DELETED";
    CampaignStatus_Enum["DRAFT"] = "DRAFT";
    CampaignStatus_Enum["HIDDEN_DRAFT"] = "HIDDEN_DRAFT";
    CampaignStatus_Enum["FAILED"] = "FAILED";
})(CampaignStatus_Enum || (CampaignStatus_Enum = {}));
export var CampaignStatus_Enum_index;
(function (CampaignStatus_Enum_index) {
    CampaignStatus_Enum_index[CampaignStatus_Enum_index["CAMPAIGN_STATUS_UNSPECIFIED"] = 0] = "CAMPAIGN_STATUS_UNSPECIFIED";
    CampaignStatus_Enum_index[CampaignStatus_Enum_index["SCHEDULED"] = 1] = "SCHEDULED";
    CampaignStatus_Enum_index[CampaignStatus_Enum_index["PROCESSING"] = 2] = "PROCESSING";
    CampaignStatus_Enum_index[CampaignStatus_Enum_index["COMPLETED"] = 3] = "COMPLETED";
    CampaignStatus_Enum_index[CampaignStatus_Enum_index["CANCELED"] = 4] = "CANCELED";
    CampaignStatus_Enum_index[CampaignStatus_Enum_index["DELETED"] = 5] = "DELETED";
    CampaignStatus_Enum_index[CampaignStatus_Enum_index["DRAFT"] = 6] = "DRAFT";
    CampaignStatus_Enum_index[CampaignStatus_Enum_index["HIDDEN_DRAFT"] = 7] = "HIDDEN_DRAFT";
    CampaignStatus_Enum_index[CampaignStatus_Enum_index["FAILED"] = 8] = "FAILED";
})(CampaignStatus_Enum_index || (CampaignStatus_Enum_index = {}));
export var CallType_Enum;
(function (CallType_Enum) {
    CallType_Enum["INVALID"] = "INVALID";
    CallType_Enum["ABANDONED"] = "ABANDONED";
    CallType_Enum["MISSED_NO_VOICEMAIL"] = "MISSED_NO_VOICEMAIL";
    CallType_Enum["MISSED_WITH_VOICEMAIL"] = "MISSED_WITH_VOICEMAIL";
})(CallType_Enum || (CallType_Enum = {}));
export var CallType_Enum_index;
(function (CallType_Enum_index) {
    CallType_Enum_index[CallType_Enum_index["INVALID"] = 0] = "INVALID";
    CallType_Enum_index[CallType_Enum_index["ABANDONED"] = 1] = "ABANDONED";
    CallType_Enum_index[CallType_Enum_index["MISSED_NO_VOICEMAIL"] = 2] = "MISSED_NO_VOICEMAIL";
    CallType_Enum_index[CallType_Enum_index["MISSED_WITH_VOICEMAIL"] = 3] = "MISSED_WITH_VOICEMAIL";
})(CallType_Enum_index || (CallType_Enum_index = {}));
export var EmailMessageDeliveryStatus_Enum;
(function (EmailMessageDeliveryStatus_Enum) {
    EmailMessageDeliveryStatus_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    EmailMessageDeliveryStatus_Enum["HIDDEN_DRAFT"] = "HIDDEN_DRAFT";
    EmailMessageDeliveryStatus_Enum["DRAFT"] = "DRAFT";
    EmailMessageDeliveryStatus_Enum["SCHEDULED"] = "SCHEDULED";
    EmailMessageDeliveryStatus_Enum["SENT"] = "SENT";
    EmailMessageDeliveryStatus_Enum["DELIVERED"] = "DELIVERED";
    EmailMessageDeliveryStatus_Enum["ERROR"] = "ERROR";
    EmailMessageDeliveryStatus_Enum["DELETED"] = "DELETED";
    EmailMessageDeliveryStatus_Enum["CANCELED"] = "CANCELED";
})(EmailMessageDeliveryStatus_Enum || (EmailMessageDeliveryStatus_Enum = {}));
export var EmailMessageDeliveryStatus_Enum_index;
(function (EmailMessageDeliveryStatus_Enum_index) {
    EmailMessageDeliveryStatus_Enum_index[EmailMessageDeliveryStatus_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    EmailMessageDeliveryStatus_Enum_index[EmailMessageDeliveryStatus_Enum_index["HIDDEN_DRAFT"] = 1] = "HIDDEN_DRAFT";
    EmailMessageDeliveryStatus_Enum_index[EmailMessageDeliveryStatus_Enum_index["DRAFT"] = 2] = "DRAFT";
    EmailMessageDeliveryStatus_Enum_index[EmailMessageDeliveryStatus_Enum_index["SCHEDULED"] = 3] = "SCHEDULED";
    EmailMessageDeliveryStatus_Enum_index[EmailMessageDeliveryStatus_Enum_index["SENT"] = 4] = "SENT";
    EmailMessageDeliveryStatus_Enum_index[EmailMessageDeliveryStatus_Enum_index["DELIVERED"] = 5] = "DELIVERED";
    EmailMessageDeliveryStatus_Enum_index[EmailMessageDeliveryStatus_Enum_index["ERROR"] = 6] = "ERROR";
    EmailMessageDeliveryStatus_Enum_index[EmailMessageDeliveryStatus_Enum_index["DELETED"] = 7] = "DELETED";
    EmailMessageDeliveryStatus_Enum_index[EmailMessageDeliveryStatus_Enum_index["CANCELED"] = 8] = "CANCELED";
})(EmailMessageDeliveryStatus_Enum_index || (EmailMessageDeliveryStatus_Enum_index = {}));
export var EmailMessageDeliveryStatusDetail_Enum;
(function (EmailMessageDeliveryStatusDetail_Enum) {
    EmailMessageDeliveryStatusDetail_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    EmailMessageDeliveryStatusDetail_Enum["DROPPED"] = "DROPPED";
    EmailMessageDeliveryStatusDetail_Enum["BOUNCED"] = "BOUNCED";
    EmailMessageDeliveryStatusDetail_Enum["NOT_SENT_INVALID"] = "NOT_SENT_INVALID";
    EmailMessageDeliveryStatusDetail_Enum["NOT_SENT_UNSUBSCRIBED"] = "NOT_SENT_UNSUBSCRIBED";
    EmailMessageDeliveryStatusDetail_Enum["NOT_SENT_MISSING_TO"] = "NOT_SENT_MISSING_TO";
    EmailMessageDeliveryStatusDetail_Enum["OTHER"] = "OTHER";
})(EmailMessageDeliveryStatusDetail_Enum || (EmailMessageDeliveryStatusDetail_Enum = {}));
export var EmailMessageDeliveryStatusDetail_Enum_index;
(function (EmailMessageDeliveryStatusDetail_Enum_index) {
    EmailMessageDeliveryStatusDetail_Enum_index[EmailMessageDeliveryStatusDetail_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    EmailMessageDeliveryStatusDetail_Enum_index[EmailMessageDeliveryStatusDetail_Enum_index["DROPPED"] = 1] = "DROPPED";
    EmailMessageDeliveryStatusDetail_Enum_index[EmailMessageDeliveryStatusDetail_Enum_index["BOUNCED"] = 2] = "BOUNCED";
    EmailMessageDeliveryStatusDetail_Enum_index[EmailMessageDeliveryStatusDetail_Enum_index["NOT_SENT_INVALID"] = 3] = "NOT_SENT_INVALID";
    EmailMessageDeliveryStatusDetail_Enum_index[EmailMessageDeliveryStatusDetail_Enum_index["NOT_SENT_UNSUBSCRIBED"] = 4] = "NOT_SENT_UNSUBSCRIBED";
    EmailMessageDeliveryStatusDetail_Enum_index[EmailMessageDeliveryStatusDetail_Enum_index["NOT_SENT_MISSING_TO"] = 5] = "NOT_SENT_MISSING_TO";
    EmailMessageDeliveryStatusDetail_Enum_index[EmailMessageDeliveryStatusDetail_Enum_index["OTHER"] = 100] = "OTHER";
})(EmailMessageDeliveryStatusDetail_Enum_index || (EmailMessageDeliveryStatusDetail_Enum_index = {}));
export var MessagingEngagement_Enum;
(function (MessagingEngagement_Enum) {
    MessagingEngagement_Enum["ENGAGEMENT_UNSPECIFIED"] = "ENGAGEMENT_UNSPECIFIED";
    MessagingEngagement_Enum["ENGAGED"] = "ENGAGED";
    MessagingEngagement_Enum["UNSUBSCRIBED"] = "UNSUBSCRIBED";
    MessagingEngagement_Enum["OPENED"] = "OPENED";
})(MessagingEngagement_Enum || (MessagingEngagement_Enum = {}));
export var MessagingEngagement_Enum_index;
(function (MessagingEngagement_Enum_index) {
    MessagingEngagement_Enum_index[MessagingEngagement_Enum_index["ENGAGEMENT_UNSPECIFIED"] = 0] = "ENGAGEMENT_UNSPECIFIED";
    MessagingEngagement_Enum_index[MessagingEngagement_Enum_index["ENGAGED"] = 1] = "ENGAGED";
    MessagingEngagement_Enum_index[MessagingEngagement_Enum_index["UNSUBSCRIBED"] = 2] = "UNSUBSCRIBED";
    MessagingEngagement_Enum_index[MessagingEngagement_Enum_index["OPENED"] = 3] = "OPENED";
})(MessagingEngagement_Enum_index || (MessagingEngagement_Enum_index = {}));
export var MessageType_Enum;
(function (MessageType_Enum) {
    MessageType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    MessageType_Enum["WEAVE_NEW_USER_INVITE"] = "WEAVE_NEW_USER_INVITE";
    MessageType_Enum["WEAVE_INSURANCE_VERIFICATION_INVITE"] = "WEAVE_INSURANCE_VERIFICATION_INVITE";
    MessageType_Enum["WEAVE_ONBOARDING"] = "WEAVE_ONBOARDING";
    MessageType_Enum["WEAVE_FORMS_OTP"] = "WEAVE_FORMS_OTP";
    MessageType_Enum["WEAVE_AUTH_MOBILE_VERIFICATION"] = "WEAVE_AUTH_MOBILE_VERIFICATION";
    MessageType_Enum["WEAVE_AUTH_PASSWORD_RESET"] = "WEAVE_AUTH_PASSWORD_RESET";
    MessageType_Enum["WEAVE_NETWORK_RECOMMENDATION"] = "WEAVE_NETWORK_RECOMMENDATION";
    MessageType_Enum["WEAVE_NOTIFICATION_VOICEMAIL"] = "WEAVE_NOTIFICATION_VOICEMAIL";
    MessageType_Enum["WEAVE_PORTING_REPORT"] = "WEAVE_PORTING_REPORT";
    MessageType_Enum["WEAVE_PORTING_NOTIFICATION"] = "WEAVE_PORTING_NOTIFICATION";
    MessageType_Enum["WEAVE_REPORT_TCR"] = "WEAVE_REPORT_TCR";
    MessageType_Enum["WEAVE_CUSTOMER_BILLING"] = "WEAVE_CUSTOMER_BILLING";
    MessageType_Enum["WEAVE_CUSTOMER_AGREEMENT"] = "WEAVE_CUSTOMER_AGREEMENT";
    MessageType_Enum["WEAVE_CALL_INTELLIGENCE_REPORT"] = "WEAVE_CALL_INTELLIGENCE_REPORT";
    MessageType_Enum["WEAVE_AUTH_MFA"] = "WEAVE_AUTH_MFA";
    MessageType_Enum["WEAVE_CALL_INTELLIGENCE_DAILY_REPORT"] = "WEAVE_CALL_INTELLIGENCE_DAILY_REPORT";
    MessageType_Enum["WEAVE_PRACTICE_ANALYTICS_HUDDLE"] = "WEAVE_PRACTICE_ANALYTICS_HUDDLE";
    MessageType_Enum["WEAVE_PAYOUT_INFO_UPDATE"] = "WEAVE_PAYOUT_INFO_UPDATE";
    MessageType_Enum["WEAVE_EMAIL_SUMMARY_DAILY_REPORT"] = "WEAVE_EMAIL_SUMMARY_DAILY_REPORT";
    MessageType_Enum["WEAVE_OVERDUE_BILLING"] = "WEAVE_OVERDUE_BILLING";
    MessageType_Enum["WEAVE_IT_EMAIL_DOMAIN_VERIFICATION"] = "WEAVE_IT_EMAIL_DOMAIN_VERIFICATION";
    MessageType_Enum["WEAVE_NOTIFICATION_APPOINTMENT_CONFIRMATION"] = "WEAVE_NOTIFICATION_APPOINTMENT_CONFIRMATION";
    MessageType_Enum["WEAVE_MOBILE_DOWNLOAD_LINK"] = "WEAVE_MOBILE_DOWNLOAD_LINK";
    MessageType_Enum["WEAVE_FORMS_DIGITIZATION_UPLOAD_REMINDER"] = "WEAVE_FORMS_DIGITIZATION_UPLOAD_REMINDER";
    MessageType_Enum["WEAVE_CALL_INTELLIGENCE_FREE_TRIAL_ACTIVATION"] = "WEAVE_CALL_INTELLIGENCE_FREE_TRIAL_ACTIVATION";
    MessageType_Enum["WEAVE_ONBOARDING_SELF_SIGNUP"] = "WEAVE_ONBOARDING_SELF_SIGNUP";
    MessageType_Enum["WEAVE_INSYS_AUTOMATION_TESTING"] = "WEAVE_INSYS_AUTOMATION_TESTING";
    MessageType_Enum["WEAVE_FORMS_SUBMISSION_CONFIRMATION"] = "WEAVE_FORMS_SUBMISSION_CONFIRMATION";
    MessageType_Enum["WEAVE_PATIENT_PORTAL_OTP"] = "WEAVE_PATIENT_PORTAL_OTP";
    MessageType_Enum["WEAVE_ONBOARDING_QUOTE_ACCEPTANCE"] = "WEAVE_ONBOARDING_QUOTE_ACCEPTANCE";
    MessageType_Enum["WEAVE_FEATURE_SUBSCRIPTION_UPGRADE_NOTIFICATION"] = "WEAVE_FEATURE_SUBSCRIPTION_UPGRADE_NOTIFICATION";
    MessageType_Enum["MESSAGING_MANUAL"] = "MESSAGING_MANUAL";
    MessageType_Enum["MESSAGING_MANUAL_BULK"] = "MESSAGING_MANUAL_BULK";
    MessageType_Enum["MESSAGING_PREFERENCE"] = "MESSAGING_PREFERENCE";
    MessageType_Enum["MESSAGING_MANUAL_FORM"] = "MESSAGING_MANUAL_FORM";
    MessageType_Enum["MESSAGING_TRUELARK"] = "MESSAGING_TRUELARK";
    MessageType_Enum["MARKETING_BIRTHDAY"] = "MARKETING_BIRTHDAY";
    MessageType_Enum["MARKETING_BULK_MESSAGES"] = "MARKETING_BULK_MESSAGES";
    MessageType_Enum["MARKETING_REVIEW_REQUEST"] = "MARKETING_REVIEW_REQUEST";
    MessageType_Enum["MARKETING_MANUAL_REVIEW_REQUEST"] = "MARKETING_MANUAL_REVIEW_REQUEST";
    MessageType_Enum["MARKETING_MANUAL_BULK_REVIEW_REQUEST"] = "MARKETING_MANUAL_BULK_REVIEW_REQUEST";
    MessageType_Enum["APPOINTMENT_REQUEST"] = "APPOINTMENT_REQUEST";
    MessageType_Enum["APPOINTMENT_REQUEST_QUICKFILL"] = "APPOINTMENT_REQUEST_QUICKFILL";
    MessageType_Enum["APPOINTMENT_RECALL"] = "APPOINTMENT_RECALL";
    MessageType_Enum["APPOINTMENT_APPROVAL"] = "APPOINTMENT_APPROVAL";
    MessageType_Enum["APPOINTMENT_SAVE_THE_DATE"] = "APPOINTMENT_SAVE_THE_DATE";
    MessageType_Enum["APPOINTMENT_REMINDER"] = "APPOINTMENT_REMINDER";
    MessageType_Enum["APPOINTMENT_FOLLOWUP"] = "APPOINTMENT_FOLLOWUP";
    MessageType_Enum["APPOINTMENT_RESCHEDULE"] = "APPOINTMENT_RESCHEDULE";
    MessageType_Enum["APPOINTMENT_REACTIVATION"] = "APPOINTMENT_REACTIVATION";
    MessageType_Enum["APPOINTMENT_CONFIRMED"] = "APPOINTMENT_CONFIRMED";
    MessageType_Enum["APPOINTMENT_MANUAL_REMINDER"] = "APPOINTMENT_MANUAL_REMINDER";
    MessageType_Enum["ORDER_READY"] = "ORDER_READY";
    MessageType_Enum["ORDER_FOLLOWUP"] = "ORDER_FOLLOWUP";
    MessageType_Enum["PAYMENT_REMINDER"] = "PAYMENT_REMINDER";
    MessageType_Enum["PAYMENT_MANUAL_REQUEST"] = "PAYMENT_MANUAL_REQUEST";
    MessageType_Enum["PAYMENT_MANUAL_PAY_OVER_TIME_REQUEST"] = "PAYMENT_MANUAL_PAY_OVER_TIME_REQUEST";
    MessageType_Enum["NOTIFICATION_MISSED_CALL"] = "NOTIFICATION_MISSED_CALL";
    MessageType_Enum["NOTIFICATION_TEXT_CONNECT"] = "NOTIFICATION_TEXT_CONNECT";
    MessageType_Enum["NOTIFICATION_MISSED_TEXT"] = "NOTIFICATION_MISSED_TEXT";
    MessageType_Enum["UPDATE_AUTO_MESSAGING_APPOINTMENT_REMINDERS_DAILY"] = "UPDATE_AUTO_MESSAGING_APPOINTMENT_REMINDERS_DAILY";
    MessageType_Enum["UPDATE_AUTO_MESSAGING_APPOINTMENT_REMINDERS_WEEKLY"] = "UPDATE_AUTO_MESSAGING_APPOINTMENT_REMINDERS_WEEKLY";
    MessageType_Enum["UPDATE_AUTO_MESSAGING_APPOINTMENT_REMINDERS_MONTHLY"] = "UPDATE_AUTO_MESSAGING_APPOINTMENT_REMINDERS_MONTHLY";
    MessageType_Enum["UPDATE_AUTO_MESSAGING_RECALL_AND_REACTIVATION_DAILY"] = "UPDATE_AUTO_MESSAGING_RECALL_AND_REACTIVATION_DAILY";
    MessageType_Enum["UPDATE_AUTO_MESSAGING_RECALL_AND_REACTIVATION_WEEKLY"] = "UPDATE_AUTO_MESSAGING_RECALL_AND_REACTIVATION_WEEKLY";
    MessageType_Enum["UPDATE_AUTO_MESSAGING_RECALL_AND_REACTIVATION_MONTHLY"] = "UPDATE_AUTO_MESSAGING_RECALL_AND_REACTIVATION_MONTHLY";
    MessageType_Enum["UPDATE_FAX_NEW_EVERY_TIME"] = "UPDATE_FAX_NEW_EVERY_TIME";
    MessageType_Enum["UPDATE_FAX_NEW_DAILY"] = "UPDATE_FAX_NEW_DAILY";
    MessageType_Enum["UPDATE_FAX_NEW_WEEKLY"] = "UPDATE_FAX_NEW_WEEKLY";
    MessageType_Enum["UPDATE_FAX_NEW_MONTHLY"] = "UPDATE_FAX_NEW_MONTHLY";
    MessageType_Enum["UPDATE_FAX_CONFIRMATION_EVERY_TIME"] = "UPDATE_FAX_CONFIRMATION_EVERY_TIME";
    MessageType_Enum["UPDATE_FAX_CONFIRMATION_DAILY"] = "UPDATE_FAX_CONFIRMATION_DAILY";
    MessageType_Enum["UPDATE_FAX_CONFIRMATION_WEEKLY"] = "UPDATE_FAX_CONFIRMATION_WEEKLY";
    MessageType_Enum["UPDATE_FAX_CONFIRMATION_MONTHLY"] = "UPDATE_FAX_CONFIRMATION_MONTHLY";
    MessageType_Enum["UPDATE_PAYMENT_ONLINE_BILL_PAY_EVERY_TIME"] = "UPDATE_PAYMENT_ONLINE_BILL_PAY_EVERY_TIME";
    MessageType_Enum["UPDATE_PAYMENT_ONLINE_BILL_PAY_DAILY"] = "UPDATE_PAYMENT_ONLINE_BILL_PAY_DAILY";
    MessageType_Enum["UPDATE_PAYMENT_ONLINE_BILL_PAY_WEEKLY"] = "UPDATE_PAYMENT_ONLINE_BILL_PAY_WEEKLY";
    MessageType_Enum["UPDATE_PAYMENT_ONLINE_BILL_PAY_MONTHLY"] = "UPDATE_PAYMENT_ONLINE_BILL_PAY_MONTHLY";
    MessageType_Enum["UPDATE_PAYMENT_TEXT_TO_PAY_EVERY_TIME"] = "UPDATE_PAYMENT_TEXT_TO_PAY_EVERY_TIME";
    MessageType_Enum["UPDATE_PAYMENT_TEXT_TO_PAY_DAILY"] = "UPDATE_PAYMENT_TEXT_TO_PAY_DAILY";
    MessageType_Enum["UPDATE_PAYMENT_TEXT_TO_PAY_WEEKLY"] = "UPDATE_PAYMENT_TEXT_TO_PAY_WEEKLY";
    MessageType_Enum["UPDATE_PAYMENT_TEXT_TO_PAY_MONTHLY"] = "UPDATE_PAYMENT_TEXT_TO_PAY_MONTHLY";
    MessageType_Enum["UPDATE_PAYMENT_TERMINAL_PAY_EVERY_TIME"] = "UPDATE_PAYMENT_TERMINAL_PAY_EVERY_TIME";
    MessageType_Enum["UPDATE_PAYMENT_TERMINAL_PAY_DAILY"] = "UPDATE_PAYMENT_TERMINAL_PAY_DAILY";
    MessageType_Enum["UPDATE_PAYMENT_TERMINAL_PAY_WEEKLY"] = "UPDATE_PAYMENT_TERMINAL_PAY_WEEKLY";
    MessageType_Enum["UPDATE_PAYMENT_TERMINAL_PAY_MONTHLY"] = "UPDATE_PAYMENT_TERMINAL_PAY_MONTHLY";
    MessageType_Enum["UPDATE_PAYMENT_MANUAL_PAY_EVERY_TIME"] = "UPDATE_PAYMENT_MANUAL_PAY_EVERY_TIME";
    MessageType_Enum["UPDATE_PAYMENT_MANUAL_PAY_DAILY"] = "UPDATE_PAYMENT_MANUAL_PAY_DAILY";
    MessageType_Enum["UPDATE_PAYMENT_MANUAL_PAY_WEEKLY"] = "UPDATE_PAYMENT_MANUAL_PAY_WEEKLY";
    MessageType_Enum["UPDATE_PAYMENT_MANUAL_PAY_MONTHLY"] = "UPDATE_PAYMENT_MANUAL_PAY_MONTHLY";
    MessageType_Enum["UPDATE_CALL_INTELLIGENCE_DAILY"] = "UPDATE_CALL_INTELLIGENCE_DAILY";
    MessageType_Enum["UPDATE_CALL_INTELLIGENCE_WEEKLY"] = "UPDATE_CALL_INTELLIGENCE_WEEKLY";
    MessageType_Enum["UPDATE_PRACTICE_ANALYTICS_MORNING_HUDDLE_DAILY"] = "UPDATE_PRACTICE_ANALYTICS_MORNING_HUDDLE_DAILY";
    MessageType_Enum["UPDATE_PRACTICE_ANALYTICS_MORNING_HUDDLE_WEEKLY"] = "UPDATE_PRACTICE_ANALYTICS_MORNING_HUDDLE_WEEKLY";
})(MessageType_Enum || (MessageType_Enum = {}));
export var MessageType_Enum_index;
(function (MessageType_Enum_index) {
    MessageType_Enum_index[MessageType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_NEW_USER_INVITE"] = 1] = "WEAVE_NEW_USER_INVITE";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_INSURANCE_VERIFICATION_INVITE"] = 2] = "WEAVE_INSURANCE_VERIFICATION_INVITE";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_ONBOARDING"] = 3] = "WEAVE_ONBOARDING";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_FORMS_OTP"] = 4] = "WEAVE_FORMS_OTP";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_AUTH_MOBILE_VERIFICATION"] = 5] = "WEAVE_AUTH_MOBILE_VERIFICATION";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_AUTH_PASSWORD_RESET"] = 6] = "WEAVE_AUTH_PASSWORD_RESET";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_NETWORK_RECOMMENDATION"] = 7] = "WEAVE_NETWORK_RECOMMENDATION";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_NOTIFICATION_VOICEMAIL"] = 8] = "WEAVE_NOTIFICATION_VOICEMAIL";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_PORTING_REPORT"] = 9] = "WEAVE_PORTING_REPORT";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_PORTING_NOTIFICATION"] = 10] = "WEAVE_PORTING_NOTIFICATION";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_REPORT_TCR"] = 11] = "WEAVE_REPORT_TCR";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_CUSTOMER_BILLING"] = 12] = "WEAVE_CUSTOMER_BILLING";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_CUSTOMER_AGREEMENT"] = 13] = "WEAVE_CUSTOMER_AGREEMENT";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_CALL_INTELLIGENCE_REPORT"] = 14] = "WEAVE_CALL_INTELLIGENCE_REPORT";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_AUTH_MFA"] = 15] = "WEAVE_AUTH_MFA";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_CALL_INTELLIGENCE_DAILY_REPORT"] = 16] = "WEAVE_CALL_INTELLIGENCE_DAILY_REPORT";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_PRACTICE_ANALYTICS_HUDDLE"] = 17] = "WEAVE_PRACTICE_ANALYTICS_HUDDLE";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_PAYOUT_INFO_UPDATE"] = 18] = "WEAVE_PAYOUT_INFO_UPDATE";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_EMAIL_SUMMARY_DAILY_REPORT"] = 19] = "WEAVE_EMAIL_SUMMARY_DAILY_REPORT";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_OVERDUE_BILLING"] = 20] = "WEAVE_OVERDUE_BILLING";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_IT_EMAIL_DOMAIN_VERIFICATION"] = 21] = "WEAVE_IT_EMAIL_DOMAIN_VERIFICATION";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_NOTIFICATION_APPOINTMENT_CONFIRMATION"] = 22] = "WEAVE_NOTIFICATION_APPOINTMENT_CONFIRMATION";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_MOBILE_DOWNLOAD_LINK"] = 23] = "WEAVE_MOBILE_DOWNLOAD_LINK";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_FORMS_DIGITIZATION_UPLOAD_REMINDER"] = 24] = "WEAVE_FORMS_DIGITIZATION_UPLOAD_REMINDER";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_CALL_INTELLIGENCE_FREE_TRIAL_ACTIVATION"] = 25] = "WEAVE_CALL_INTELLIGENCE_FREE_TRIAL_ACTIVATION";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_ONBOARDING_SELF_SIGNUP"] = 26] = "WEAVE_ONBOARDING_SELF_SIGNUP";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_INSYS_AUTOMATION_TESTING"] = 27] = "WEAVE_INSYS_AUTOMATION_TESTING";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_FORMS_SUBMISSION_CONFIRMATION"] = 28] = "WEAVE_FORMS_SUBMISSION_CONFIRMATION";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_PATIENT_PORTAL_OTP"] = 29] = "WEAVE_PATIENT_PORTAL_OTP";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_ONBOARDING_QUOTE_ACCEPTANCE"] = 30] = "WEAVE_ONBOARDING_QUOTE_ACCEPTANCE";
    MessageType_Enum_index[MessageType_Enum_index["WEAVE_FEATURE_SUBSCRIPTION_UPGRADE_NOTIFICATION"] = 31] = "WEAVE_FEATURE_SUBSCRIPTION_UPGRADE_NOTIFICATION";
    MessageType_Enum_index[MessageType_Enum_index["MESSAGING_MANUAL"] = 51] = "MESSAGING_MANUAL";
    MessageType_Enum_index[MessageType_Enum_index["MESSAGING_MANUAL_BULK"] = 52] = "MESSAGING_MANUAL_BULK";
    MessageType_Enum_index[MessageType_Enum_index["MESSAGING_PREFERENCE"] = 53] = "MESSAGING_PREFERENCE";
    MessageType_Enum_index[MessageType_Enum_index["MESSAGING_MANUAL_FORM"] = 54] = "MESSAGING_MANUAL_FORM";
    MessageType_Enum_index[MessageType_Enum_index["MESSAGING_TRUELARK"] = 55] = "MESSAGING_TRUELARK";
    MessageType_Enum_index[MessageType_Enum_index["MARKETING_BIRTHDAY"] = 101] = "MARKETING_BIRTHDAY";
    MessageType_Enum_index[MessageType_Enum_index["MARKETING_BULK_MESSAGES"] = 102] = "MARKETING_BULK_MESSAGES";
    MessageType_Enum_index[MessageType_Enum_index["MARKETING_REVIEW_REQUEST"] = 103] = "MARKETING_REVIEW_REQUEST";
    MessageType_Enum_index[MessageType_Enum_index["MARKETING_MANUAL_REVIEW_REQUEST"] = 104] = "MARKETING_MANUAL_REVIEW_REQUEST";
    MessageType_Enum_index[MessageType_Enum_index["MARKETING_MANUAL_BULK_REVIEW_REQUEST"] = 105] = "MARKETING_MANUAL_BULK_REVIEW_REQUEST";
    MessageType_Enum_index[MessageType_Enum_index["APPOINTMENT_REQUEST"] = 151] = "APPOINTMENT_REQUEST";
    MessageType_Enum_index[MessageType_Enum_index["APPOINTMENT_REQUEST_QUICKFILL"] = 152] = "APPOINTMENT_REQUEST_QUICKFILL";
    MessageType_Enum_index[MessageType_Enum_index["APPOINTMENT_RECALL"] = 153] = "APPOINTMENT_RECALL";
    MessageType_Enum_index[MessageType_Enum_index["APPOINTMENT_APPROVAL"] = 154] = "APPOINTMENT_APPROVAL";
    MessageType_Enum_index[MessageType_Enum_index["APPOINTMENT_SAVE_THE_DATE"] = 155] = "APPOINTMENT_SAVE_THE_DATE";
    MessageType_Enum_index[MessageType_Enum_index["APPOINTMENT_REMINDER"] = 156] = "APPOINTMENT_REMINDER";
    MessageType_Enum_index[MessageType_Enum_index["APPOINTMENT_FOLLOWUP"] = 157] = "APPOINTMENT_FOLLOWUP";
    MessageType_Enum_index[MessageType_Enum_index["APPOINTMENT_RESCHEDULE"] = 158] = "APPOINTMENT_RESCHEDULE";
    MessageType_Enum_index[MessageType_Enum_index["APPOINTMENT_REACTIVATION"] = 159] = "APPOINTMENT_REACTIVATION";
    MessageType_Enum_index[MessageType_Enum_index["APPOINTMENT_CONFIRMED"] = 160] = "APPOINTMENT_CONFIRMED";
    MessageType_Enum_index[MessageType_Enum_index["APPOINTMENT_MANUAL_REMINDER"] = 161] = "APPOINTMENT_MANUAL_REMINDER";
    MessageType_Enum_index[MessageType_Enum_index["ORDER_READY"] = 201] = "ORDER_READY";
    MessageType_Enum_index[MessageType_Enum_index["ORDER_FOLLOWUP"] = 202] = "ORDER_FOLLOWUP";
    MessageType_Enum_index[MessageType_Enum_index["PAYMENT_REMINDER"] = 251] = "PAYMENT_REMINDER";
    MessageType_Enum_index[MessageType_Enum_index["PAYMENT_MANUAL_REQUEST"] = 252] = "PAYMENT_MANUAL_REQUEST";
    MessageType_Enum_index[MessageType_Enum_index["PAYMENT_MANUAL_PAY_OVER_TIME_REQUEST"] = 253] = "PAYMENT_MANUAL_PAY_OVER_TIME_REQUEST";
    MessageType_Enum_index[MessageType_Enum_index["NOTIFICATION_MISSED_CALL"] = 301] = "NOTIFICATION_MISSED_CALL";
    MessageType_Enum_index[MessageType_Enum_index["NOTIFICATION_TEXT_CONNECT"] = 302] = "NOTIFICATION_TEXT_CONNECT";
    MessageType_Enum_index[MessageType_Enum_index["NOTIFICATION_MISSED_TEXT"] = 303] = "NOTIFICATION_MISSED_TEXT";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_AUTO_MESSAGING_APPOINTMENT_REMINDERS_DAILY"] = 1000] = "UPDATE_AUTO_MESSAGING_APPOINTMENT_REMINDERS_DAILY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_AUTO_MESSAGING_APPOINTMENT_REMINDERS_WEEKLY"] = 1001] = "UPDATE_AUTO_MESSAGING_APPOINTMENT_REMINDERS_WEEKLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_AUTO_MESSAGING_APPOINTMENT_REMINDERS_MONTHLY"] = 1002] = "UPDATE_AUTO_MESSAGING_APPOINTMENT_REMINDERS_MONTHLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_AUTO_MESSAGING_RECALL_AND_REACTIVATION_DAILY"] = 1005] = "UPDATE_AUTO_MESSAGING_RECALL_AND_REACTIVATION_DAILY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_AUTO_MESSAGING_RECALL_AND_REACTIVATION_WEEKLY"] = 1006] = "UPDATE_AUTO_MESSAGING_RECALL_AND_REACTIVATION_WEEKLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_AUTO_MESSAGING_RECALL_AND_REACTIVATION_MONTHLY"] = 1007] = "UPDATE_AUTO_MESSAGING_RECALL_AND_REACTIVATION_MONTHLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_FAX_NEW_EVERY_TIME"] = 1050] = "UPDATE_FAX_NEW_EVERY_TIME";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_FAX_NEW_DAILY"] = 1051] = "UPDATE_FAX_NEW_DAILY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_FAX_NEW_WEEKLY"] = 1052] = "UPDATE_FAX_NEW_WEEKLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_FAX_NEW_MONTHLY"] = 1053] = "UPDATE_FAX_NEW_MONTHLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_FAX_CONFIRMATION_EVERY_TIME"] = 1055] = "UPDATE_FAX_CONFIRMATION_EVERY_TIME";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_FAX_CONFIRMATION_DAILY"] = 1056] = "UPDATE_FAX_CONFIRMATION_DAILY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_FAX_CONFIRMATION_WEEKLY"] = 1057] = "UPDATE_FAX_CONFIRMATION_WEEKLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_FAX_CONFIRMATION_MONTHLY"] = 1058] = "UPDATE_FAX_CONFIRMATION_MONTHLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_ONLINE_BILL_PAY_EVERY_TIME"] = 1100] = "UPDATE_PAYMENT_ONLINE_BILL_PAY_EVERY_TIME";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_ONLINE_BILL_PAY_DAILY"] = 1101] = "UPDATE_PAYMENT_ONLINE_BILL_PAY_DAILY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_ONLINE_BILL_PAY_WEEKLY"] = 1102] = "UPDATE_PAYMENT_ONLINE_BILL_PAY_WEEKLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_ONLINE_BILL_PAY_MONTHLY"] = 1103] = "UPDATE_PAYMENT_ONLINE_BILL_PAY_MONTHLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_TEXT_TO_PAY_EVERY_TIME"] = 1105] = "UPDATE_PAYMENT_TEXT_TO_PAY_EVERY_TIME";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_TEXT_TO_PAY_DAILY"] = 1106] = "UPDATE_PAYMENT_TEXT_TO_PAY_DAILY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_TEXT_TO_PAY_WEEKLY"] = 1107] = "UPDATE_PAYMENT_TEXT_TO_PAY_WEEKLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_TEXT_TO_PAY_MONTHLY"] = 1108] = "UPDATE_PAYMENT_TEXT_TO_PAY_MONTHLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_TERMINAL_PAY_EVERY_TIME"] = 1110] = "UPDATE_PAYMENT_TERMINAL_PAY_EVERY_TIME";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_TERMINAL_PAY_DAILY"] = 1111] = "UPDATE_PAYMENT_TERMINAL_PAY_DAILY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_TERMINAL_PAY_WEEKLY"] = 1112] = "UPDATE_PAYMENT_TERMINAL_PAY_WEEKLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_TERMINAL_PAY_MONTHLY"] = 1113] = "UPDATE_PAYMENT_TERMINAL_PAY_MONTHLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_MANUAL_PAY_EVERY_TIME"] = 1115] = "UPDATE_PAYMENT_MANUAL_PAY_EVERY_TIME";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_MANUAL_PAY_DAILY"] = 1116] = "UPDATE_PAYMENT_MANUAL_PAY_DAILY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_MANUAL_PAY_WEEKLY"] = 1117] = "UPDATE_PAYMENT_MANUAL_PAY_WEEKLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PAYMENT_MANUAL_PAY_MONTHLY"] = 1118] = "UPDATE_PAYMENT_MANUAL_PAY_MONTHLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_CALL_INTELLIGENCE_DAILY"] = 1150] = "UPDATE_CALL_INTELLIGENCE_DAILY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_CALL_INTELLIGENCE_WEEKLY"] = 1151] = "UPDATE_CALL_INTELLIGENCE_WEEKLY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PRACTICE_ANALYTICS_MORNING_HUDDLE_DAILY"] = 1200] = "UPDATE_PRACTICE_ANALYTICS_MORNING_HUDDLE_DAILY";
    MessageType_Enum_index[MessageType_Enum_index["UPDATE_PRACTICE_ANALYTICS_MORNING_HUDDLE_WEEKLY"] = 1201] = "UPDATE_PRACTICE_ANALYTICS_MORNING_HUDDLE_WEEKLY";
})(MessageType_Enum_index || (MessageType_Enum_index = {}));
export var AttributionType_Enum;
(function (AttributionType_Enum) {
    AttributionType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    AttributionType_Enum["APPOINTMENTS_SCHEDULED"] = "APPOINTMENTS_SCHEDULED";
    AttributionType_Enum["APPOINTMENTS_CONFIRMED"] = "APPOINTMENTS_CONFIRMED";
    AttributionType_Enum["APPOINTMENTS_COMPLETED"] = "APPOINTMENTS_COMPLETED";
    AttributionType_Enum["MESSAGES_REPLIED"] = "MESSAGES_REPLIED";
    AttributionType_Enum["LINKS_CLICKED"] = "LINKS_CLICKED";
    AttributionType_Enum["AMOUNTS_COLLECTED"] = "AMOUNTS_COLLECTED";
})(AttributionType_Enum || (AttributionType_Enum = {}));
export var AttributionType_Enum_index;
(function (AttributionType_Enum_index) {
    AttributionType_Enum_index[AttributionType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    AttributionType_Enum_index[AttributionType_Enum_index["APPOINTMENTS_SCHEDULED"] = 1] = "APPOINTMENTS_SCHEDULED";
    AttributionType_Enum_index[AttributionType_Enum_index["APPOINTMENTS_CONFIRMED"] = 2] = "APPOINTMENTS_CONFIRMED";
    AttributionType_Enum_index[AttributionType_Enum_index["APPOINTMENTS_COMPLETED"] = 3] = "APPOINTMENTS_COMPLETED";
    AttributionType_Enum_index[AttributionType_Enum_index["MESSAGES_REPLIED"] = 4] = "MESSAGES_REPLIED";
    AttributionType_Enum_index[AttributionType_Enum_index["LINKS_CLICKED"] = 5] = "LINKS_CLICKED";
    AttributionType_Enum_index[AttributionType_Enum_index["AMOUNTS_COLLECTED"] = 6] = "AMOUNTS_COLLECTED";
})(AttributionType_Enum_index || (AttributionType_Enum_index = {}));
